// ./games/crash/state/phases/TakeOffPhase.ts

import type { IPhase, PhaseContext } from './IPhase';
import { isStompTick, StompMessage } from '@core/Web/types/StompMessage';
import { FlyingPhase } from './FlyingPhase';
import { DummyTickGenerator } from './DummyTickGenerator'; // NEW: Import the utility class
import { shouldAdvanceLocalGameClock } from '@Web/config/connectionHealth';

export class TakeOffPhase implements IPhase {
  constructor(private context: PhaseContext) {}

  // --- NEW: Use the utility class for state management ---
  private dummyTickGenerator!: DummyTickGenerator;
  // --- (All old dummy tick state and config properties are removed) ---

  onEnter(): void {
    console.log('[Phase] ==> Entering TAKEOFF phase.');
    this.context.store.getState().setPhase('TAKEOFF');

    // --- NEW: Initialize the utility class ---
    this.dummyTickGenerator = new DummyTickGenerator(
      this.context.store.getState().nowX
    );
  }

  onExit(): void {
    console.log('[Phase] <== Exiting TAKEOFF phase.');
  }

  // MODIFIED: Simplified to use the generator class
  handleMessage(message: StompMessage): void {
    if (isStompTick(message) && message.multiplier >= 1.0) {
      console.log(
        `[Phase][TakeOff] Received first tick > 1.0 (${message.multiplier}x). Transitioning to FLYING.`
      );

      // --- FIX: Only set tick if it's higher than the current one
      if (message.multiplier > this.context.store.getState().nowX) {
        this.context.store.getState().setTick(message.multiplier, message.ts);
      }

      // --- NEW: Register the real tick with the generator ---
      this.dummyTickGenerator.registerRealTick(message.multiplier);

      this.context.manager.transitionTo(new FlyingPhase(this.context));
    }
  }

  // MODIFIED: Simplified to use the generator class
  update(deltaTime: number): void {
    if (
      !shouldAdvanceLocalGameClock(
        this.context.store.getState().connectionStatus
      )
    ) {
      return;
    }
    if (!this.dummyTickGenerator) {
      return;
    }

    // --- NEW: Dummy Tick Generation ---
    const currentMultiplier = this.context.store.getState().nowX;
    const newDummyMultiplier = this.dummyTickGenerator.update(
      deltaTime,
      currentMultiplier
    );

    if (newDummyMultiplier) {
      // The generator determined a new dummy tick should be set
      this.context.store.getState().setTick(newDummyMultiplier, Date.now());
    }
    // --- END: Dummy Tick Generation ---
  }
}
